import React from 'react';
import { useMatch } from 'react-router-dom';

const ErrorResponse = () => {
  const match = useMatch('clientapp/error/:statusCode/:requestId');
  const { requestId, statusCode } = match.params;
  
  return (
    <div className="error-message">
      <h1 className="error-info">An error occurred while processing your request</h1>
      <h3 className="error-more">Response StatusCode: {statusCode}</h3>
      <h3 className="error-more">RequestId: {requestId}</h3>
    </div>
  );
}

export default ErrorResponse;